import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BrandsComponent } from './brands/brands.component';
import { CreateOrEditBrandModalComponent } from './brands/create-or-edit-brand-modal.component';
import { CategoriesComponent } from './categories/categories.component';
import { CreateOrEditCategoryModalComponent } from './categories/create-or-edit-category-modal.component';
import { CreateOrEditDepartmentModalComponent } from './departments/create-or-edit-department-modal.component';
import { DepartmentsComponent } from './departments/departments.component';
import { CreateOrEditSubCategoryModalComponent } from './subCategories/create-or-edit-subCategory-modal.component';
import { SubCategoriesComponent } from './subCategories/subCategories.component';
import { CreateOrEditUnitModalComponent } from './units/create-or-edit-unit-modal.component';
import { UnitsComponent } from './units/units.component';
import { PriceGroupsComponent } from './priceGroups/priceGroups.component';
import { CreateOrEditPriceGroupModalComponent } from './priceGroups/create-or-edit-priceGroup-modal.component';
import { ProductsComponent } from './products/products.component';
import { CreateOrEditProductComponent } from './products/create-or-edit-product.component';
import { AverageCostMovementComponent } from './reports/average-cost-movement/average-cost-movement.component';
import { DailyMovementComponent } from './reports/daily-movement/daily-movement.component';
import { DepartmentStockComponent } from './reports/department-stock/department-stock.component';
import { FifoExpiryComponent } from './reports/fifo-expiry/fifo-expiry.component';
import { InventoryAgingComponent } from './reports/inventory-aging/inventory-aging.component';
import { InventoryAgingDetailComponent } from './reports/inventory-aging-detail/inventory-aging-detail.component';
import { InventoryMovementComponent } from './reports/inventory-movement/inventory-movement.component';
import { InventoryPriceAuditTrailComponent } from './reports/inventory-price-audit-trail/inventory-price-audit-trail.component';
import { InventorySerialMovementComponent } from './reports/inventory-serial-movement/inventory-serial-movement.component';
import { InventoryStockComponent } from './reports/inventory-stock/inventory-stock.component';
import { InventoryStockByDateComponent } from './reports/inventory-stock-by-date/inventory-stock-by-date.component';
import { ProductBatchSerialStockComponent } from './reports/product-batch-serial-stock/product-batch-serial-stock.component';
import { ProductMaterialsDetailComponent } from './reports/product-materials-detail/product-materials-detail.component';
import { ProductWeightComponent } from './reports/product-weight/product-weight.component';
import { PurchaseCostVariationLogComponent } from './reports/purchase-cost-variation-log/purchase-cost-variation-log.component';
import { StockActualQtyComponent } from './reports/stock-actual-qty/stock-actual-qty.component';
import { StockMovementComponent } from './reports/stock-movement/stock-movement.component';

const routes: Routes = [
  {
    path: 'subCategories',
    children: [
      {
        path: '',
        component: SubCategoriesComponent, // list
      },
      {
        path: 'createOrEdit',
        component: CreateOrEditSubCategoryModalComponent,
      }
    ]
  },
  {
    path: 'units',
    children: [
      {
        path: '',
        component: UnitsComponent, // list
      },
      {
        path: 'createOrEdit',
        component: CreateOrEditUnitModalComponent,
      }
    ]
  },
  {
    path: 'brands',
    children: [
      {
        path: '',
        component: BrandsComponent, // list
      },
      {
        path: 'createOrEdit',
        component: CreateOrEditBrandModalComponent,
      }
    ]
  },
    {
    path: 'departments',
    children: [
      {
        path: '',
        component: DepartmentsComponent, // list
      },
      {
        path: 'createOrEdit',
        component: CreateOrEditDepartmentModalComponent,
      }
    ]
  },
    {
    path: 'categories',
    children: [
      {
        path: '',
        component: CategoriesComponent, // list
      },
      {
        path: 'createOrEdit',
        component: CreateOrEditCategoryModalComponent,
      }
    ]
  },
  {
    path: 'priceGroups',
    children: [
      {
        path: '',
        component: PriceGroupsComponent, // list
      },
      {
        path: 'createOrEdit',
        component: CreateOrEditPriceGroupModalComponent,
      }
    ]
  },
  {
    path: 'products',
    children: [
      {
        path: '',
        component: ProductsComponent, // list
      },
      {
        path: 'createOrEdit',
        component: CreateOrEditProductComponent,
      }
    ]
  },
  {
    path: 'average-cost-movement',
    children: [
      {
        path: '',
        component: AverageCostMovementComponent,
      }
    ]
  },
  {
    path: 'department-stock',
    children: [
      {
        path: '',
        component: DepartmentStockComponent,
      }
    ]
  },
  {
    path: 'inventory-movement',
    children: [
      {
        path: '',
        component: InventoryMovementComponent,
      }
    ]
  },
  
  
  {
    path: 'inventory-stock',
    children: [
      {
        path: '',
        component: InventoryStockComponent,
      }
    ]
  },
  {
    path: 'inventory-stock-by-date',
    children: [
      {
        path: '',
        component: InventoryStockByDateComponent,
      }
    ]
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InventoryRoutingModule { }
